import type React from 'react';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import type { FacetClickSource } from './Filter.types';
import { useToggleFilter } from './useToggleFilter';

const isValidFacetSource = (source: string | undefined): source is FacetClickSource => !!source && ['mobileDrawer', 'sidebar', 'togglePill'].includes(source);

/**
 * Shared `onChange` handler for filter facet checkboxes. Reads the option, source and
 * presented facet off the input's data attributes and hands off to `useToggleFilter`.
 */
export const useFilterChangeHandler = () => {
  const toggleFilter = useToggleFilter();

  return useEventCallback<React.ChangeEventHandler<HTMLInputElement>>(evt => {
    const { target } = evt;
    const compositeCode = target.dataset.itemId;
    if (!target.disabled && compositeCode && isValidFacetSource(target.dataset.source)) {
      toggleFilter(compositeCode, target.checked, { source: target.dataset.source, facet: target.dataset.facet });
    }
  });
};
